import style from "./FormPost.module.css";
import React, { useState, useEffect, useContext } from "react";
import UserContext from "../../../store/user-context";
import { useLocation } from "react-router-dom";
import TextEditor from "./TextEditor";
import UploadImage from "./UploadImage";
import axios from "axios";

const FormPost = () => {
  const userContext = useContext(UserContext);
  const [judul, setJudul] = useState("");
  const [post, setPost] = useState("");
  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [idPost, setIdPost] = useState(null);
  const { search } = useLocation();
  const queryParam = new URLSearchParams(search);
  const idParam = queryParam.get("id");
  /**
   * Menggunakan variabel yang bernilai false dan isLoading di set ke false hanya pada saat variable bernilai false
   * adalah cara agar tidak ada error can't perform react ....
   *
   * lebih jelasnya
   * https://www.youtube.com/watch?v=rLiMo8Vk61E
   */

  const onImageUpload = (e) => {
    const fileImage = e.target.files[0];
    setImage(fileImage);

    /**
     * mengambil data yang disimpan sementara
     * jika di refresh akan hilang
     */
    setImagePreview(URL.createObjectURL(fileImage));
    e.target.value = null;
  };

  const createPost = async (e) => {
    e.preventDefault();
    // console.log(image);
    setLoading(true);
    // Memasukan nilai nilai yang akan di simpan ke database
    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("post", post);
    if (post.length <= 8) {
      formData.append("post", "");
    }
    formData.append("foto", image);
    formData.append("id_user", userContext.user.id);
    formData.append("status", "pending");

    // Mengirim data melalui Api
    const token = localStorage.getItem("token");
    await axios
      .post(process.env.REACT_APP_LINK_API + "post", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setError(false);
        setSuccess("Postingan Anda Telah Terkirim");
        const data = response.data.data;
        setImage("");
        setEdit(true);
        setIdPost(data.id);

        window.history.replaceState(
          null,
          "Edit Post",
          `/create-post?id=${data.id}&action=edit`
        );
      })
      .catch((error) => {
        setSuccess(false);
        setError(error.response.data.errors);
        const data = error.response.data.errors;
      });

    setLoading(false);
  };

  const updatePost = async (e) => {
    e.preventDefault();

    setLoading(true);
    console.log("hiiii");
    // Memasukan nilai nilai yang akan di simpan ke database
    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("post", post);
    formData.append("foto", image);
    formData.append("id_user", userContext.user.id);
    formData.append("status", "pending");

    // Mengirim data melalui Api
    const token = localStorage.getItem("token");
    await axios
      .post(
        process.env.REACT_APP_LINK_API + "post/update/" + idPost,
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setError(false);
        setSuccess("Postingan Anda Telah di Update");
      })
      .catch((error) => {
        setSuccess(false);
        setError(error.response.data);
      });

    setLoading(false);
  };

  useEffect(() => {
    if (idParam) {
      setIdPost(idParam);
      const fetchData = async () => {
        await axios
          .get(`${process.env.REACT_APP_LINK_API}post/${idParam}`)
          .then((res) => {
            setJudul(res.data.data.judul);
            setEdit(true);
          })
          .catch((error) => {
            console.log(error.response.data);
          });
      };
      fetchData();
    }
  }, []);

  return (
    <div className={`container-md ${style.container_write} ${style.write}`}>
      {success && <div className="alert alert-success">{success}</div>}
      <div className="row">
        {error.foto && <p className={style.text_error}>{error.foto[0]}</p>}
        <div className="col-md-12 d-flex justify-content-center">
          {imagePreview && (
            <img className={style.writeImg} src={imagePreview} alt="" />
          )}
        </div>
      </div>
      <form className="writeForm" onSubmit={edit ? updatePost : createPost}>
        <div className="row mb-4">
          {error.judul && <p className={style.text_error}>{error.judul[0]}</p>}
          <div className={`col-2 ${style.container_icon}`}>
            <UploadImage onChange={(e) => onImageUpload(e)} />
          </div>
          <div className="col-7">
            <input
              className={style.writeInput}
              placeholder="Title"
              type="text"
              autoFocus={true}
              onChange={(e) => setJudul(e.target.value)}
              value={judul}
            />
          </div>
          <div className="col-3">
            <button className="btn btn-success" type="submit">
              {loading == true ? "Mengirim .... " : "Publish"}
            </button>
          </div>
        </div>
        <div className="row">
          {error.post && <p className={style.text_error}>{error.post[0]}</p>}
          <div className="col-md-12 d-flex justify-content-center">
            <TextEditor dapatkanData={(e) => setPost(e)} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormPost;
